// From wp_localize_script in WP
export const WP_Localized_Data = MCI22_Localize;

// Media Queries
export const mediaQueryBreakpoints = WP_Localized_Data.mediaQuery;
export const mediaQueryBreakpointXS = mediaQueryBreakpoints.xs;
export const mediaQueryBreakpointSM = mediaQueryBreakpoints.sm;
export const mediaQueryBreakpointMD = mediaQueryBreakpoints.md;
export const mediaQueryBreakpointLG = mediaQueryBreakpoints.lg;

// Api keys
export const apiKeys = WP_Localized_Data.apiKeys;

// AjaxUrl
export const ajaxUrl = WP_Localized_Data.ajax_url;

// Offset
export function offset(el) {
	const rect = el.getBoundingClientRect();
	const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// DOM
export function getNextSibling(elem, selector) {

	// Get the next sibling element
	let sibling = elem.nextElementSibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) {
			return sibling;
		}
		sibling = sibling.nextElementSibling
	}
	return null;
}

export function loadScript(src) {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.onload = resolve
		script.onerror = reject
		script.src = src
		document.head.append(script);
	});
}

// Vimeo API
export let isVimeoAPILoaded = false;
export function loadVimeoAPI(callback, argsArray) {
	if(isVimeoAPILoaded) {
		callback.apply(this, argsArray);
	}
	else {
		loadScript('https://player.vimeo.com/api/player.js').then(() => {
			isVimeoAPILoaded = true;
			callback.apply(this, argsArray);
		});
	}
}

// YouTube API
export let isYoutubeAPILoaded = false;
export function loadYoutubeAPI(callback, argsArray) {
	if(isYoutubeAPILoaded) {
		callback.apply(this, argsArray);
	}
	else {
		// Loads the YouTube IFrame Player API code asynchronously.
		const tag	= document.createElement('script');
		tag.src	= "https://www.youtube.com/iframe_api";
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		window.onYouTubeIframeAPIReady = () => {
			isYoutubeAPILoaded = true;
			callback.apply(this, argsArray);
		};
	}
}

// History
export function updateQueryStringParam(key, value, uri) {
	if(!uri) {
		uri = window.location.href;
	}

	const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	const separator = uri.indexOf('?') !== -1 ? '&' : '?';

	if(uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	}
	else {
		return (uri + separator + key + '=' + value);
	}
}

//
// Cookies
export function setCookie(name, value, hours) {
	if(hours) {
		const d = new Date;
		d.setTime(d.getTime() + 60*60*1000*hours);
		document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}
	else {
		document.cookie = name + "=" + value + ";path=/";
	}
}
export function getCookie(name) {
	const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
}
export function deleteCookie(name) {
	setCookie(name, '', -1);
}

//
// Cookie consent
export function hasCookieConsentMarketing() {
	return true;
}
export function hasCookieConsentStatistics() {
	return true;
}

//
// Animation
export function expandElement(el, callback) {
	// get the height of the element's inner content, regardless of its actual size
	const elementHeight = el.scrollHeight;

	// have the element transition to the height of its inner content
	el.style.height = elementHeight + 'px';

	// when the next css transition finishes (which should be the one we just triggered)
	const onTransitionEnd = () => {
		// remove "height" from the element's inline styles, so it can return to its initial value
		el.style.height = null;
		el.removeEventListener('transitionend', onTransitionEnd);
		if(callback) {
			callback();
		}
	};
	el.addEventListener('transitionend', onTransitionEnd);
}
export function collapseElement(el, callback) {
	// get the height of the element's inner content, regardless of its actual size
	const elementHeight = el.scrollHeight;

	// temporarily disable all css transitions
	const elementTransition = el.style.transition;
	el.style.transition = '';

	// on the next frame (as soon as the previous style change has taken effect),
	// explicitly set the element's height to its current pixel height, so we
	// aren't transitioning out of 'auto'
	requestAnimationFrame(() => {
		el.style.height = elementHeight + 'px';
		el.style.transition = elementTransition;

		// on the next frame (as soon as the previous style change has taken effect),
		// have the element transition to height: 0
		requestAnimationFrame(() => {
			el.style.height = 0 + 'px';
			if(callback) {
				callback();
			}
		});
	});
}

//
// Numbers
export function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function numberWithPeriods(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

//
// Validation
export function isValidEmail(email) {
	return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}
export function isValidTextInput(text, minLength = 0, maxLength = null) {
	if(maxLength) {
		return text.length > minLength && text.length <= maxLength
	}
	return text.length > minLength;
}
export function isValidPassword(password) {
	if(/\s/.test(password)) { // Check for any type of whitespace
		return false;
	}
	return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,200}$/g.test(password);
}
export function isValidPhoneNumber(number) {
	return /^(0045|\+45)?[0-9]{8}$/.test(number);
}

//
// Post data
export async function postData(url= '', data = {}) {

	const response = await fetch(url, {
		method: 'POST',
		mode: 'cors',
		header: new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}),
		body: data,
		credentials: 'same-origin',
		cache: 'no-store',
	});
	return response.json(); // parses JSON response into native JavaScript objects
}